import React from 'react';
import SignatureForm from './SignatureForm';
import { Modal } from 'src/components/new/modal/Modal';
import { ModalTitle } from 'src/components/new/modal/ModalTitle';
import { ModalContent } from 'src/components/new/modal/ModalContent';
import { ModalFooter } from 'src/components/new/modal/ModalFooter';
import { Drawer } from '@mui/material';

interface SignatureDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  type: 'add' | 'edit';
}

const SignatureDialog: React.FC<SignatureDialogProps> = ({ open, onClose, onSubmit, type }) => {
  return (
    <Drawer
      open={open}
      anchor="right"
      onClose={onClose}
      sx={{
        '& .MuiPaper-root': {
          background: '#FFF',
        },
        '& .MuiDrawer-paper': {
          width: '37.5rem',
        },
      }}
    >
      <ModalTitle onClose={onClose}>{type === 'add' ? 'Add Signature' : 'Edit Signature'}</ModalTitle>
      <ModalContent>
        <SignatureForm />
      </ModalContent>
      <ModalFooter onClose={onClose} onSubmit={onSubmit} submitText='Save' />
    </Drawer>
  );
};

export default SignatureDialog;
